export const AUTH_TOKEN_KEY = 'aa-vie_client_auth_token'
export const USER_KEY = 'aa-vie_client_auth_user'
